const records = 'customers';
const contacts = 'customer-contacts';
const shippingAddresses = 'customer-shipping-addresses';
const terms = 'terms';
const materialPreferences = 'customer-material-preferences';

export default {
  records,
  contacts,
  shippingAddresses,
  terms,
  materialPreferences,
};
